import merge from 'lodash/merge';
import {useMemo} from 'react';
import {UrlLink} from '../../../applink/UrlLink';
import {twMerge} from '../../../common/twMerge';
import {PageViewCustomPropsDataKey} from '../../../logging/PageViewCustomPropsDataKey.enum';
import {DAY_OF_WEEK_TAB_ITEM_SIZE_PX} from '../DayOfWeekTabItem/constants';
import {DayOfWeekTabItem} from '../DayOfWeekTabItem/DayOfWeekTabItem';
import {
  DAY_OF_WEEK_TAB_ITEMS_MAX_GAP_PX,
  DAY_OF_WEEK_TAB_X_PADDING_PX,
} from './constants';
import {DayOfWeekTabProps} from './DayOfWeekTabProps.interface';

export function DayOfWeekTab({
  tabItems,
  currentTabItemParam,
  onClickTabItem,
  className,
  style,
  ...props
}: DayOfWeekTabProps) {
  const tabMaxWidth = useMemo(() => {
    const totalGapPx = Math.max(
      (tabItems.length - 1) * DAY_OF_WEEK_TAB_ITEMS_MAX_GAP_PX,
      0
    );

    return (
      tabItems.length * DAY_OF_WEEK_TAB_ITEM_SIZE_PX +
      totalGapPx +
      DAY_OF_WEEK_TAB_X_PADDING_PX * 2
    );
  }, [tabItems.length]);

  return (
    <div
      className={twMerge(
        'h-50pxr w-full border-b border-solid border-theme-transparent-20 bg-theme-bg-base',
        className
      )}
    >
      <div
        className="flex h-full w-full flex-row items-center justify-between"
        style={merge(
          {
            maxWidth: tabMaxWidth,
          },
          style
        )}
        {...props}
      >
        {tabItems.map(tabItem => {
          const isSelected = currentTabItemParam === tabItem.param;
          return (
            <div
              key={tabItem.param}
              {...{
                [PageViewCustomPropsDataKey.PageDay]: isSelected
                  ? `page_day=${tabItem.name}`
                  : undefined,
              }}
              className="flex justify-center overflow-hidden"
            >
              <UrlLink url={tabItem.href}>
                <DayOfWeekTabItem
                  isSelected={isSelected}
                  onClick={e => onClickTabItem(tabItem.param, e)}
                >
                  {tabItem.name}
                </DayOfWeekTabItem>
              </UrlLink>
            </div>
          );
        })}
      </div>
    </div>
  );
}
